import templateUrl from 'emun.salesrep/salesrep-sales-goals.htm';
import productSalesPopup from "emun.salesrep/product-sales-popup";
import salesrepConfig from 'emun.salesrep/salesrep.config';

class SalesRepSalesGoalsController {
	constructor($window, $rootScope, retailerPrompt, createAutoQuery, utils) {
		let $ctrl = this;
		var context = $ctrl.context || 'executive';
		$ctrl.utils = utils;

		var repFilter = "";
		if (context === 'manager') {
			repFilter = "&ManagerId=" + $ctrl.rep.id;
		}

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup && $ctrl.repGroupId) {
			repFilter = '&RepGroup=' + $ctrl.repGroupId;
		}

		//        var url = 'QueryOrderLineTotals.json?dateRange=YTD&grouping=strCategory' + repFilter;
		var url = 'QuerySalesYOYTotals.json?Sum=TotalSalesYearToDate,TotalSalesYearToDateLastYear&GroupBy=SalesRepId,SalesRepName' + repFilter;

		if ($ctrl.repGroup !== 'ALL' && $ctrl.repGroup) {
			url = url + '&RepGroupName=' + $ctrl.repGroup;
		}
		if ($ctrl.insideSales === 'true') {
			url = url + '&IsInsideSales=true';
		}
		$ctrl.salesTotals = createAutoQuery({
			url: url,
			autoLoad: true,
			take: 1000,
			onLoaded: function (totals) {
				var salesGoalsUrl = 'QuerySalesRepGoals.json?Sum=SalesGoalThisYear&GroupBy=SalesRepId';
				if ($ctrl.repGroup) {
					if ($ctrl.repGroup !== 'ALL') {
						salesGoalsUrl = salesGoalsUrl + '&RepGroupName=' + $ctrl.repGroup;
					}
				}
				if ($ctrl.insideSales !== 'true') {
					salesGoalsUrl = salesGoalsUrl + '&IsInsideSales=false';
				}
				$ctrl.salesGoals = createAutoQuery({
					url: salesGoalsUrl,
					autoLoad: true,
					take: 1000,
					onLoaded: function (goals) {
						totals.results.forEach(function (total) {
							total.goal = 0;
							goals.results.forEach(function (goal) { 
								if (total.salesRepId === goal.salesRepId) {
									total.goal += goal.sumSalesGoalThisYear;
									if (total.goal > 0) {
										total.percent = Math.round((total.sumTotalSalesYearToDate / total.goal) * 100);
									} else {
										total.percent = 0;
									}
								}
							});
						});
					}
				});
			}
		});
	}
	downloadData() {
		let $ctrl = this;
		var itemsFormatted = [];

		var headers = {
			name: 'Sales Rep',
			ytdSales: "YTD Sales",
			lytdSales: "LYTD Sales",
			goal: " YTD Goal",
			percent: "% of Goal"
		};

		// format the data
		$ctrl.salesTotals.results.forEach((item) => {
			itemsFormatted.push({
				name: item.salesRepName.replace(/,/g, ''), // remove commas to avoid errors,
				ytdSales: item.sumTotalSalesYearToDate,
				lytdSales: item.sumTotalSalesYearToDateLastYear,
				goal: item.goal,
				percent: item.percent
			});
		});

		var fileTitle = 'salesrep-sales';
		$ctrl.utils.exportCSVFile(headers, _.sortBy(itemsFormatted, 'ytdSales').reverse(), fileTitle);
	}
}

let SalesRepSalesGoals = {
	bindings: {
		rep: '<',
		repGroup: '@',
		repGroupId: '@',
		context: '@',
		mode: '@',
		insideSales: '@',
		writingRepId: '@'
	},
	//require:{
	//    container: '^salesrepDashboard'
	//},
	controller: SalesRepSalesGoalsController,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};

export default SalesRepSalesGoals;